import IconButton from '@mui/material/IconButton';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import colors from 'styles/colors';
import { useModalContext } from '../ModalContext';
import FullScreenDialog from './FullScreenDialog';

const FullScreenResizer = ({ children, contentStyles, title }) => {
  const { openModal, closeModal } = useModalContext();

  const handleFullScreen = () => {
    openModal({
      content: (
        <FullScreenDialog
          onClose={closeModal}
          title={title}
        >
          {children}
        </FullScreenDialog>
      ),
    });
  };

  return (
    <div style={{ textAlign: 'end' }}>
      <IconButton
        onClick={handleFullScreen}
        sx={{ padding: 0, marginBottom: '10px' }}
      >
        <FullscreenIcon
          fontSize="small"
          sx={{
            color: colors.text.primary,
            '&:hover': {
              color: colors.text.secondary,
            },
          }}
        />
      </IconButton>
      <div style={contentStyles}>
        {children}
      </div>
    </div>
  );
};

export default FullScreenResizer;
